module.exports = __webpack_public_path__ + "static/img/14areaB_8.1931f8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/14areaB_8.png
// module id = 1122
// module chunks = 1